export const ERROR_CODES: Record<string, number> = {
    XML_PARSING_ERROR: 100,
    VAST_SCHEMA_VALIDATION_ERROR: 101,
};

export default ERROR_CODES;
